const states = {
  nlp_details: {
    intents: [],
    entities: [],
    workflows: [],
    actions: [],
  },
}
export default states
